<div class="container-fluid primary-account-page">
  <nav class="context-breadcrumb" aria-label="breadcrumb  rounded ">
    <ol class="breadcrumb  shadow-lg">
      <li class="breadcrumb-item"><a routerLink="/utilisateur/admin/dashboard">Dashboard administration</a></li>
      <li class="breadcrumb-item active" aria-current="page">Comptes utilisateurs</li>
    </ol>
  </nav>

  <div class="card border-0 table-shell">
    <div class="card-header generalbgColorV2 text-white table-head">
      <div>
        <h5 class="mb-1">Comptes utilisateurs</h5>
        <p class="mb-0 table-subtitle">Visualisation complete des comptes personnels et business</p>
      </div>
    </div>
    <div class="card-body">
      <div class="summary-chips mb-3">
        <span class="summary-chip">{{ totalUsers }} utilisateurs</span>
        <span class="summary-chip">{{ totalPrimaryUsers }} comptes personnels</span>
        <span class="summary-chip">{{ totalBusinessUsers }} comptes business</span>
        <span class="summary-chip summary-chip-ok">{{ totalVerifiedUsers }} identites verifiees</span>
      </div>

      <div class="table-responsive">
        <table class="table account-table align-middle table-borderless" id="utilisateur">
          <thead>
            <tr>
              <th>ID</th>
              <th>Identite</th>
              <th>Nom</th>
              <th>Prenom</th>
              <th>Telephone</th>
              <th>Username</th>
              <th>Type compte</th>
              <th>Compte personnel</th>
              <th>Compte affaire</th>
              <th>Gestionnaire</th>
              <th>Mot de passe</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let person of persons; trackBy: trackByPersonId">
              <td>
                <span class="id-chip">#{{ person.id }}</span>
              </td>
              <td>
                <span class="identity-pill" [ngClass]="getIdentityClass(person)">
                  <i class="bi" [ngClass]="isIdentityVerified(person) ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'"></i>
                  {{ getIdentityLabel(person) }}
                </span>
              </td>
              <td class="fw-semibold text-uppercase">{{ person.firstName }}</td>
              <td class="fw-semibold text-uppercase">{{ person.lastName }}</td>
              <td>{{ person.phone }}</td>
              <td>{{person.email}}</td>

              <td>
                <div class="account-types">
                  <span class="badge badge-secondary mr-1" *ngIf="person.hasPrimaryAccount">personnel</span>
                  <span class="badge badge-success" *ngIf="person.hasBusinessAccount">business</span>
                </div>
              </td>

              <td>
                <button type="button" class="btn btn-secondary btn-sm action-btn"
                  (click)="getAccountInformation(person.id,person.firstName,person.lastName)"
                  title="Voir le compte personnel">
                  <i class="bi bi-eye mr-2"></i>
                </button>
              </td>
              <td>
                <button type="button" class="btn btn-secondary btn-sm action-btn" [disabled]="!person.hasBusinessAccount"
                  (click)="getBusinessAccountInformation(person.id,person.firstName,person.lastName)"
                  title="Voir le compte affaire">
                  <i class="bi bi-eye mr-2"></i>
                </button>
              </td>
              <td>
                <button type="button" class="btn btn-secondary btn-sm action-btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                  (click)="initModalGestionnaire(person.id,person.firstName,person.lastName)"
                  title="Affecter un gestionnaire">
                  <i class="bi bi-person-badge mr-2"></i>
                </button>
              </td>
              <td>
                <button class="btn btn-outline-primary btn-sm action-btn" (click)="UpdateUserPassword(person.id)"
                  title="Reinitialiser le mot de passe">
                  <i class="bi bi-arrow-clockwise"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">choisir un gestionaire</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="gestionaireFeedbackMessage" class="alert"
          [ngClass]="{
            'alert-success': gestionaireFeedbackType === 'success',
            'alert-danger': gestionaireFeedbackType === 'error'
          }"
          role="alert">
          {{ gestionaireFeedbackMessage }}
        </div>
        <form>
          <div class="form-group" *ngIf="hasAssignedGestionaire">
            <label for="exampleFormControlInput1">utilisateur</label>
            <input type="text" class="form-control" id="exampleFormControlInput1" [value]="gestionaire" readonly>
          </div>
          <div class="form-group">
            <label for="exampleFormControlSelect2">gestionaire</label>
            <select multiple class="form-control" id="exampleFormControlSelect2"
              (click)="gestionaireIdSave($event.target.value)">
              <option *ngFor="let p of gestionaireList;" value="{{p.id}}">{{p.firstName}} {{p.lastName}}</option>

            </select>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" [disabled]="isAssigningGestionaire" (click)="addGestionaire()">
          {{ isAssigningGestionaire ? 'enregistrement...' : 'enregistrer' }}
        </button>
      </div>
    </div>
  </div>
</div>
